import { Wordmark } from '@/components/wordmark';

/**
 * The decorative half of the auth card.
 *
 * shadcn's login-04/signup-04 blocks ship a full-bleed `placeholder.svg` here.
 * There is no marketing art to put in its place, so this carries the same
 * visual weight with the app icon the sidebar and favicon already use, and the
 * signed-out and signed-in surfaces read as the same product.
 */
export function AuthAside() {
  return (
    <div className="bg-muted relative hidden items-center justify-center overflow-hidden md:flex">
      <div
        aria-hidden
        className="from-primary/10 absolute inset-0 bg-gradient-to-br via-transparent to-transparent"
      />

      <div className="relative flex flex-col items-center gap-4">
        <img src="/icon-192.png" alt="" className="size-14 rounded-2xl" />

        <div className="flex flex-col items-center gap-2 text-center">
          <Wordmark className="h-5 w-auto" />
          <p className="text-muted-foreground text-sm">Operator console</p>
        </div>
      </div>
    </div>
  );
}
